exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.link[data-v-7c41e6c6]:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
